import React from "react";
// import InfiniteHorizontalScroll from "../howItWorks/Animtion1";
import { Link } from "react-router-dom";

const Download = () => {
  return (
    <div className="flex-col hidden sm:flex gap-14">
      <div className="px-4 sm:px-8 lg:px-28">
        <div className="bg-gradient-to-r from-[#d8dff7] to-[#beb9f1] flex items-center rounded-[32px]">
          <div className="flex flex-col gap-5 md:gap-7 lg:gap-9 w-[50%] ml-6 md:ml-11 my-8">
            <img
              src="/img/webpImg/Tbd-Logo.webp"
              alt="Logo"
              className="w-[105px] md:w-[120px] lg:w-[130px]"
            />
            <div className="flex flex-col gap-3 lg:gap-3.5">
              <h2 className="text-[#7E54F2] text-[28px] md:text-[32px] lg:text-[38px] font-bold leading-[103%]">
                Get Hot Deals on Your Phone
              </h2>
              <p className="text-[#000] text-[16px] md:text-[20px] lg:text-[24px] leading-[110%]">
                Get instant notifications for the loot deals from your favourite
                stores.
              </p>
            </div>
            <div className="flex flex-col gap-1 md:gap-2 lg:gap-3.5">
              <p className="text-base md:text-[20px] lg:text-[24px] font-bold leading-[35px] tracking-[1px] uppercase">
                Download the app now !
              </p>
              <div className="items-center hidden gap-5 sm:flex">
                <Link
                  className="cursor-pointer"
                  to="https://apps.apple.com/in/app/tbd-the-deals-app/id6741994389"
                  target="_blank"
                >
                  <picture>
                    <source
                      media="(max-width: 639px)"
                      srcSet="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                    />
                    <img
                      src="/img/webpImg/Apple-Store-Button.webp"
                      alt="download option"
                      className="w-[130px]"
                    />
                  </picture>
                  {/* <p className="text-sm text-center opacity-70">coming soon</p> */}
                </Link>
                <div>
                  <Link
                    className="cursor-pointer"
                    to="https://play.google.com/store/apps/details?id=com.the_best_dealsApp"
                    target="_blank"
                  >
                    <picture>
                      <source
                        media="(max-width: 639px)"
                        srcSet="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                      />
                      <img
                        src="/img/webpImg/Google-Play-Button.webp"
                        alt="download option"
                        className="w-[130px]"
                      />
                    </picture>
                  </Link>
                  {/* <p className="opacity-0">h</p> */}
                </div>
              </div>
            </div>
          </div>

          <picture>
            <source
              media="(max-width: 639px)"
              srcSet="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
            />
            <img
              src="/img/webpImg/Deals-Image.webp"
              alt="Image"
              className="w-[100%] self-end"
            />
          </picture>
        </div>
      </div>
    </div>
  );
};

export default Download;
